import { useNavigate } from 'react-router-dom'
import { useSellerTabContext } from '../../context/SellerTabContext'
import styles from './ArtistLinks.module.css'

interface ArtistLinksProps {
  artists: string | any[]
}

export function ArtistLinks({ artists }: ArtistLinksProps) {
  const navigate = useNavigate()
  const sellerTabCtx = useSellerTabContext()

  const openArtistTab = (e: React.MouseEvent, artistId: number, artistName: string) => {
    e.stopPropagation()
    if (sellerTabCtx) {
      sellerTabCtx.openArtistTab(artistId, artistName)
      return
    }
    try {
      const saved = localStorage.getItem('stonks_artist_tabs')
      const tabs: any[] = saved ? JSON.parse(saved) : []
      const existing = tabs.find((t: any) => t.artistId === artistId)
      let activeId: number
      if (existing) {
        activeId = existing.id
      } else {
        const newTab = { id: Date.now(), name: artistName, artistId }
        tabs.push(newTab)
        localStorage.setItem('stonks_artist_tabs', JSON.stringify(tabs))
        activeId = newTab.id
      }
      localStorage.setItem('stonks_artist_active_tab', activeId.toString())
    } catch { /* ignore */ }
    navigate('/artists')
  }

  if (typeof artists === 'string') {
    return <span>{artists}</span>
  }

  if (!Array.isArray(artists) || artists.length === 0) {
    return <span>Unknown Artist</span>
  }

  return (
    <>
      {artists.map((a: any, i: number) => (
        <span key={i}>
          {i > 0 && ', '}
          {a.id ? (
            <button
              className={styles.artistLink}
              onClick={(e) => openArtistTab(e, a.id, a.name || String(a))}
            >
              {a.name || String(a)}
            </button>
          ) : (
            <span>{a.name || String(a)}</span>
          )}
        </span>
      ))}
    </>
  )
}
